import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import type { Components } from 'react-markdown'
import { looksLikeMermaid, MermaidBlock } from './MermaidDiagram'

function CodeBlock({
  className,
  children,
}: {
  className?: string
  children?: React.ReactNode
}) {
  const text = String(children ?? '').replace(/\n$/, '')
  const lang = /language-(\w+)/.exec(className || '')?.[1]?.toLowerCase()
  if (looksLikeMermaid(text, lang)) {
    return <MermaidBlock code={text} idPrefix="askai-mmd" />
  }
  return (
    <pre className="not-prose overflow-x-auto rounded-lg border border-m2-outline-variant bg-[#0f172a] p-3 text-xs leading-relaxed text-[#e2e8f0]">
      <code className={`${className || ''} text-[#e2e8f0]`}>{text}</code>
    </pre>
  )
}

const components: Components = {
  code({ className, children, ...props }) {
    const isBlock = Boolean(className) || String(children).includes('\n')
    if (!isBlock) {
      return (
        <code
          className="rounded bg-[#e8efe8] px-1 py-0.5 text-[0.85em] font-semibold text-[#0f3e17]"
          {...props}
        >
          {children}
        </code>
      )
    }
    return <CodeBlock className={className}>{children}</CodeBlock>
  },
  pre({ children }) {
    return <>{children}</>
  },
}

export default function AskAiMarkdown({ content }: { content: string }) {
  return (
    <div className="prose prose-sm max-w-none text-[#222222] prose-headings:text-[#222222] prose-p:text-[#222222] prose-li:text-[#222222] prose-strong:text-[#222222] prose-code:text-[#0f3e17] prose-pre:bg-transparent prose-pre:p-0 prose-pre:text-[#e2e8f0]">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {content}
      </ReactMarkdown>
    </div>
  )
}
